/* Coming-soon page interactions: before/after split slider + scroll reveals. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- before/after split slider ----- */
  if (!customElements.get('split-view')) {
    customElements.define(
      'split-view',
      class SplitView extends HTMLElement {
        connectedCallback() {
          this.handle = this.querySelector('.cs-split__handle');
          this.interacted = false;
          this.pos = parseFloat(this.dataset.start || '22');
          this.setPos(this.pos);

          this.addEventListener('pointerdown', this.onPointerDown.bind(this));
          this.addEventListener('pointermove', this.onPointerMove.bind(this));
          this.addEventListener('pointerup', this.onPointerUp.bind(this));
          this.addEventListener('pointercancel', this.onPointerUp.bind(this));
          if (this.handle) this.handle.addEventListener('keydown', this.onKeyDown.bind(this));

          /* Invite interaction: sweep the light on once the slider scrolls into view. */
          if (!reducedMotion && 'IntersectionObserver' in window) {
            var self = this;
            var seen = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  seen.disconnect();
                  setTimeout(function () { self.nudge(); }, 350);
                }
              });
            }, { threshold: 0.45 });
            seen.observe(this);
          } else {
            this.setPos(50);
          }
        }

        setPos(value) {
          this.pos = Math.max(0, Math.min(100, value));
          this.style.setProperty('--pos', this.pos + '%');
          this.classList.toggle('is-full-on', this.pos > 92);
          this.classList.toggle('is-full-off', this.pos < 8);
          if (this.handle) this.handle.setAttribute('aria-valuenow', String(Math.round(this.pos)));
        }

        posFromEvent(event) {
          var rect = this.getBoundingClientRect();
          return ((event.clientX - rect.left) / rect.width) * 100;
        }

        onPointerDown(event) {
          this.interacted = true;
          if (this.raf) cancelAnimationFrame(this.raf);
          this.classList.add('is-dragging');
          this.setPointerCapture(event.pointerId);
          this.setPos(this.posFromEvent(event));
        }

        onPointerMove(event) {
          if (!this.classList.contains('is-dragging')) return;
          this.setPos(this.posFromEvent(event));
        }

        onPointerUp() {
          this.classList.remove('is-dragging');
        }

        onKeyDown(event) {
          var step = event.shiftKey ? 10 : 4;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            this.interacted = true;
            this.setPos(this.pos - step);
            event.preventDefault();
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            this.interacted = true;
            this.setPos(this.pos + step);
            event.preventDefault();
          } else if (event.key === 'Home') {
            this.interacted = true;
            this.setPos(0);
            event.preventDefault();
          } else if (event.key === 'End') {
            this.interacted = true;
            this.setPos(100);
            event.preventDefault();
          }
        }

        /* Animate from the dark start to a mid split, hinting at the effect. */
        nudge() {
          if (this.interacted) return;
          var self = this;
          var from = this.pos;
          var to = parseFloat(this.dataset.rest || '46');
          var overshoot = Math.min(96, to + 22);
          var duration = 1900;
          var start = null;

          function ease(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          }

          function frame(now) {
            if (self.interacted) return;
            if (start === null) start = now;
            var t = Math.min(1, (now - start) / duration);
            var e = ease(t);
            var value;
            /* Rise to an overshoot, then settle back to the resting split. */
            if (e < 0.62) value = from + (overshoot - from) * (e / 0.62);
            else value = overshoot - (overshoot - to) * ((e - 0.62) / 0.38);
            self.setPos(value);
            if (t < 1) self.raf = requestAnimationFrame(frame);
          }
          this.raf = requestAnimationFrame(frame);
        }
      }
    );
  }

  /* ----- reveal on scroll ----- */
  var targets = document.querySelectorAll('.cs-reveal');
  if (reducedMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );
    targets.forEach(function (el) { observer.observe(el); });
  }
})();
